import React from 'react'
import { TeamMember as TeamMemberType } from 'types'
import BioSvg from './BIO.svg'
import Image from '@components/Image'

interface PropsType {
  id: number
  skeleton?: boolean
  iconsStyle?: string
  member?: TeamMemberType
}

const TeamMember_2 = ({ id, member, skeleton, iconsStyle }: PropsType) => {
  // ID constants
  const teamMemberId = 'TeamMember-' + id
  const teamMemberName = 'TeamMemberModal-' + id
  const teamMemberAria = 'TeamMemberModalLabel-' + id

  // Grey filter function to apply styles
  const booleanGreyFilter = (filterStyle: boolean | string | undefined): string => {
    if (typeof filterStyle === 'string') {
      return filterStyle.toLowerCase() === 'true' ? ' filter-grey' : ''
    }
    return filterStyle ? ' filter-grey' : ''
  }

  // Check member bioParagraphs prop to show or hide button
  const checkBioParagraphs = (member?: string[] | undefined | null): boolean | undefined => {
    if (member && member?.length > 0) {
      const arrValues: any[] = member?.map((m) => m?.length)
      return !(arrValues?.length <= 1) ? true : arrValues[0] > 0
    } else return false
  }

  return (
    <>
      {/* Team member */}
      <div
        id={teamMemberId}
        className={'column-team b card rounded-0 px-0' + (skeleton ? ' skeleton-column-team' : '')}
      >
        {/* Team member row */}
        <div className={'row g-0 team-member' + (skeleton ? ' skeleton-team-member' : '')}>
          {/* Image col */}
          <div className="col-md-5 col-xxl-5 img-col d-flex justify-content-center justify-content-xxl-start">
            {skeleton ? (
              <div className="member-img img-fluid skeleton-img"></div>
            ) : (
              <Image
                className={'member-img img-fluid' + booleanGreyFilter(member?.filterStyle)}
                objectFit="cover"
                alt={member?.name!}
                image={member?.image_gatsby!}
              />
            )}
          </div>
          {/* Text col */}
          <div className="col-md-7 col-xxl-7 d-flex justify-content-center align-items-center px-2">
            <div className="card-body">
              <h4
                className={
                  'mb-3 pb-3 complete-name text-uppercase text-center text-md-start' +
                  (skeleton ? ' skeleton-name mb-2 border-0' : ' w-100')
                }
              >
                {member?.name} <br className={'d-none d-md-block' + (skeleton ? ' d-none' : '')} />
                {member?.surname}
              </h4>
              <p
                className={
                  'bold mb-3 position text-center text-md-start ' +
                  (skeleton ? ' skeleton-position' : '')
                }
              >
                {member?.position}
              </p>
              <a
                href={'mailto:' + member?.email}
                className={
                  'mb-3 email d-block text-center text-md-start' +
                  (skeleton ? ' skeleton-email' : '')
                }
              >
                {member?.email}
              </a>
              {checkBioParagraphs(member?.bioParagraphs) && (
                <button
                  type="button"
                  className={'btn btn-primary bio fst-italic d-block' + (skeleton ? ' d-none' : '')}
                  data-bs-toggle="modal"
                  data-bs-target={`#${teamMemberName}`}
                >
                  Ver bio
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {checkBioParagraphs(member?.bioParagraphs) && (
        <div
          className="modal fade team-member-modal"
          id={teamMemberName}
          tabIndex={-1}
          aria-labelledby={teamMemberAria}
          aria-hidden="true"
          style={{ zIndex: 100000 }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content rounded-0 position-relative pt-3 pb-4 px-4">
              <div className="modal-header align-items-center border-0 z-1">
                <h1
                  className="modal-title align-self-end"
                  id={teamMemberAria}
                >
                  BIO
                </h1>
                <button
                  type="button"
                  className="btn-close align-self-baseline"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className={'icon-close' + iconsStyle}></i>
                </button>
              </div>
              <div className="modal-body mt-4 mb-5 z-1">
                {member?.bioParagraphs?.map((b, i) => (
                  <p
                    key={i}
                    className="mb-4"
                  >
                    {b}
                  </p>
                ))}
              </div>
              <div className="modal-footer border-0 justify-content-center mt-5 mb-3 z-1">
                <h4 className="name-footer text-uppercase">
                  {member?.name} {member?.surname}
                </h4>
              </div>
              <img
                src={BioSvg}
                className="img-fluid position-absolute z-0 bio-svg"
                alt="BIO"
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default TeamMember_2
